import { useNavigate } from 'react-router-dom';

// Falls back to a fixed route instead of browser-back when there's no app
// history to go back to (e.g. someone lands directly on this page via URL).
export default function BackButton({ fallback = '/' }) {
  const navigate = useNavigate();
  return (
    <button
      type='button'
      className='back-button'
      onClick={() => {
        if (window.history.length > 1) navigate(-1);
        else navigate(fallback);
      }}
    >
      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
        <path d='M15 18l-6-6 6-6' />
      </svg>
      Back
    </button>
  );
}
